<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-container">
      <h3 class="title">知行悦房旅后台</h3>
      <p class="login-sub">年轻好看的房子，从这里管起</p>
      <el-form-item prop="username">
        <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp">吉ICP备2026010258号</a>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
export default {
  name: 'login',
  data() {
    return {
      logining: false,
      rememberpwd: false,
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getuserpwd()
  },
  methods: {
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          var UserDCO = {
            'username': this.ruleForm.username,
            'password': this.ruleForm.password
          }
          login(UserDCO).then(res => {
            if (res.status == 200) {
              if (this.rememberpwd) {
                setCookie('user', this.ruleForm.username, 7)
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              setTimeout(() => {
                this.logining = false
                localStorage.setItem('logintoken', res.data.token)
                localStorage.setItem('role', res.data.user.role)
                localStorage.setItem('userdata', JSON.stringify(res.data.user))
                this.$store.commit('login', 'true')
                this.$router.push({ path: '/home/dashboard' })
              }, 600)
            } else {
              this.$message.error('用户名或密码错误')
              this.logining = false
            }
          }, error => {
            this.$message.error(error && error.message ? error.message : '登录失败')
            this.logining = false
          })
        } else {
          this.$message.error('请输入用户名密码！')
          this.logining = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 11%;
  background:
    radial-gradient(circle at 12% 18%, rgba(255, 107, 107, 0.55), transparent 28%),
    radial-gradient(circle at 86% 12%, rgba(139, 92, 246, 0.7), transparent 32%),
    radial-gradient(circle at 80% 78%, rgba(20, 184, 166, 0.45), transparent 30%),
    linear-gradient(160deg, #1b1433 0%, #312e81 48%, #5b67f1 100%);
  position: relative;
  overflow: hidden;
}
.login-container {
  border-radius: 22px;
  margin: 0 auto;
  width: 380px;
  padding: 40px 36px 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 60px rgba(27, 20, 51, 0.28);
  position: relative;
  z-index: 1;
}
.title {
  margin: 0 auto 8px;
  text-align: center;
  color: #1f1633;
  letter-spacing: 1px;
  font-size: 22px;
}
.login-sub {
  margin: 0 0 28px;
  text-align: center;
  color: #8b5cf6;
  font-size: 13px;
}
.remember {
  margin: 0 0 28px;
  color: #6b6480;
}
.icp {
  position: absolute;
  bottom: 24px;
  left: 0;
  width: 100%;
  text-align: center;
  color: rgba(255,255,255,.7);
  text-decoration: none;
  font-size: 12px;
}

@media (orientation: landscape) and (max-height: 540px) {
  .login-wrap {
    padding: 24px 16px 56px;
    overflow: auto;
  }
  .login-container {
    width: min(420px, 92vw);
    padding: 20px 24px 16px;
  }
  .title {
    font-size: 20px;
  }
  .login-sub {
    margin-bottom: 16px;
  }
  .remember {
    margin-bottom: 16px;
  }
  .icp {
    bottom: 10px;
  }
}

@media (orientation: landscape) and (min-width: 768px) and (max-width: 1366px) {
  .login-wrap {
    padding-top: 8%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue